import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=50046c80&"
import script from "./rate.vue?vue&type=script&lang=js&"
export * from "./rate.vue?vue&type=script&lang=js&"
import style0 from "./rate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rate.vue"
export default component.exports